import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form } from "react-bootstrap";
import SelectDropDown from '../../selectdropdown/SelectDropDown'
import { components } from 'react-select'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import CardLessDataTable from "../../datatables/CardLessDataTableWithSearch";
import moment from "moment";
import FeeStatusModal from './FeeModal';
import FeeReportDateWise from './FeeReportDateWise'

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

class StudentPayments extends Component {
    constructor(props) {
        super(props)
        this.state = {
            studentnameSearch: "0",
            studentnameSearchval: "",

            classSearch: "0",
            classSearchval: "",

            examSearch: "0",
            examSearchval: "",

            sectionSearch: "0",
            sectionSearchval: "",

            branchSearch: "0",
            branchSearchval: "",

            categorySearch: "0",
            categorySearchval: "",
            confirmPassword: "",
            passwordValid: true,
            examValid: true,
            confirmPasswordValid: true,
            cButton: true,
            mobile: "",
            loadingSpinner: 0,
            feeModal: false,
            studentPaymentData: [],
            totalAmount: 0,
            studentMobile: "",
            tutionFee: 0,
            individualDetails: [],
            student_name: "",
            exam_name: "",

            getExams: [],
            getClasses: [],
            getSections: [],
            roll_no: "",
            row_branch_id: 0,
            feeReportDateWiseModal: false
        }
    };

    selecthandleInputChange = (ename, evalue) => {
        const name = ename;
        const value = evalue;
        console.log("aaaaaa", ename, evalue);
        if (name == "branchSearch") {
            if (value != "0") {
                let branchSearchData = this.props.globals.globalBranches.find((a) => a.id == value);
                this.setState({
                    branchSearchval: {
                        value: branchSearchData.id,
                        label: branchSearchData.branch_name
                    },
                    branch: branchSearchData.branch_name,

                    examSearch: "0",
                    examSearchval: "",
                    getExams: [],

                    classSearch: "0",
                    classSearchval: "",
                    getClasses: [],

                    sectionSearch: "0",
                    sectionSearchval: "",
                    getSections: [],
                })
                this.dropDownGetValues('examSearch', value)
            } else {
                this.setState({
                    branchSearchval: {
                        value: "0",
                        label: "Select Branch"
                    },
                    branchSearch: "0",
                    branchSearchval: "",

                    examSearch: "0",
                    examSearchval: "",
                    getExams: [],

                    classSearch: "0",
                    classSearchval: "",
                    getClasses: [],

                    sectionSearch: "0",
                    sectionSearchval: "",
                    getSections: [],
                })
            }
        } else if (name == "examSearch") {
            if (value != "0") {
                let examSearchData = this.props.globals.exams.find((a) => a.id == value);
                this.setState({
                    examSearchval: {
                        value: examSearchData.id,
                        label: examSearchData.exam
                    },
                    exam: examSearchData.exam,
                    classSearch: "0",
                    classSearchval: "",
                    getClasses: [],

                    sectionSearch: "0",
                    sectionSearchval: "",
                    getSections: [],
                })
                this.dropDownGetValues('classSearch', value)
            } else {
                this.setState({
                    sectionSearchval: {
                        value: "0",
                        label: "Select Exam"
                    },
                    classSearch: "0",
                    classSearchval: "",
                    getClasses: [],

                    sectionSearch: "0",
                    sectionSearchval: "",
                    getSections: [],
                })
            }
        } else if (name == "classSearch") {
            if (value != "0") {
                let classSearchData = this.props.globals.educationalClasses.find((a) => a.id == value);
                this.setState({
                    classSearchval: {
                        value: classSearchData.id,
                        label: classSearchData.class
                    },
                    class: classSearchData.class,
                    sectionSearch: "0",
                    sectionSearchval: "",
                    getSections: [],
                })
                this.dropDownGetValues('sectionSearch', value);
            } else {
                this.setState({
                    classSearchval: {
                        value: "0",
                        label: "Select Class"
                    },
                    sectionSearch: "0",
                    sectionSearchval: "",
                    getSections: [],
                })
            }
        } else if (name == "sectionSearch") {
            if (value != "0") {
                let sectionSearchData = this.props.globals.globalSections.find((a) => a.id == value);
                this.setState({
                    sectionSearchval: {
                        value: sectionSearchData.id,
                        label: sectionSearchData.section_name
                    },
                    section: sectionSearchData.section_name,
                })
            } else {
                this.setState({
                    sectionSearchval: {
                        value: "0",
                        label: "Select Section"
                    },
                })
            }
        }
        this.setState({ [name]: value });
    };

    dropDownGetValues(fieldname, value) {
        let getArray = [];

        if (fieldname == "branchSearch") {
            const newObj1 = {
                value: "0",
                label: "Select Branch"
            }
            getArray.push(newObj1);
        } else if (fieldname == "examSearch") {
            const newObj1 = {
                value: "0",
                label: "Select Exam"
            }
            getArray.push(newObj1);
        } else if (fieldname == "classSearch") {
            const newObj1 = {
                value: "0",
                label: "Select Class"
            }
            getArray.push(newObj1);
        } else if (fieldname == "sectionSearch") {
            const newObj1 = {
                value: "0",
                label: "Select Section"
            }
            getArray.push(newObj1);
        }

        if (fieldname == "branchSearch") {
            let uniqueBranches = [...new Set(this.props.globals.b_e_c_s_data.map((item) => item.branch_id))];
            uniqueBranches.map((val) => {
                let individualBranchData = this.props.globals.globalBranches.find((item1) => item1.id == val);
                const newObj = {
                    value: individualBranchData.id,
                    label: individualBranchData.branch_name
                }
                getArray.push(newObj);
            })
        } else if (fieldname == "examSearch") {
            let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();
            uniqueExams.map((val) => {
                let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                const newObj = {
                    value: individualExamData.id,
                    label: individualExamData.exam
                }
                getArray.push(newObj);
            })
            this.setState({ getExams: getArray })

        } else if (fieldname == "classSearch") {

            let uniqueClasses = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == value).map((item1) => item1.class_id))].sort();

            uniqueClasses.map((val) => {
                let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                const newObj = {
                    value: individualClassData.id,
                    label: individualClassData.class
                }
                getArray.push(newObj);
            })

            this.setState({ getClasses: getArray })

        } else if (fieldname == "sectionSearch") {
            let uniqueSections = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == this.state.examSearch && item.class_id == value).map((item1) => item1.section_id))].sort();
            uniqueSections.map((val) => {
                let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                const newObj = {
                    value: individualSectionData.id,
                    label: individualSectionData.section_name
                }
                getArray.push(newObj);
            })
            this.setState({ getSections: getArray })
        }
        return getArray;
    };

    tableData(students) {
        console.log("students", students);
        const student_data = Array();

        for (let i = 0; i < students.length; i++) {
            const branchs = this.props.globals.globalBranches.find(
                (e) => e.id == students[i].branch_id
            );
            let b_id = "";
            let branch1 = "";
            if (branchs != undefined) {
                branch1 = branchs.branch_name;
                b_id = branchs.id;
            }
            const exams = this.props.globals.exams.find(
                (e) => e.id == students[i].exam_id
            );
            let exam_id = "";
            let examName = "";
            if (exams != undefined) {
                examName = exams.exam;
                exam_id = exams.id;
            }

            const classes = this.props.globals.classes.find(
                (e) => e.id == students[i].class_id
            );
            let c_id = "";
            let class1 = "";
            if (classes != undefined) {
                class1 = classes.class;
                c_id = classes.id;
            }
            const packages = this.props.globals.globalPackages.find(
                (e) => e.id == students[i].package_id
            );
            let p_id = "";
            let package1 = "";
            if (packages != undefined) {
                package1 = packages.package_name;
                p_id = packages.id;
            }
            const categories = this.props.globals.globalCategories.find(
                (e) => e.id == students[i].category_id
            );
            let cc_id = "";
            let category1 = "";
            if (categories != undefined) {
                category1 = categories.category_name;
                cc_id = categories.id;
            }
            const sections = this.props.globals.globalSections.find(
                (e) => e.id == students[i].section_id
            );
            let s_id = "";
            let section1 = "";
            if (sections != undefined) {
                section1 = sections.section_name;
                s_id = sections.id;
            }

            student_data.push({
                id: students[i].id,
                student_name: students[i].student_name,
                roll_no: students[i].roll_no,
                exam_name: examName,
                exam_id: exam_id,
                branch_name: branch1,
                class_name: class1,
                package_id: package1,
                category_id: category1,
                section_name: section1,
                branch: b_id,
                class: c_id,
                package: p_id,
                category: cc_id,
                section: s_id,
                pending_amount: students[i].pending_amount,
                paid_amount: students[i].paid_amount,
                total_amount: students[i].total_amount,
                term_details: students[i].term_details,
                student_mobile: students[i].student_mobile,
                tutionFee: students[i].tutionFee,
                individualDetails: students[i].individualDetails
            });
        }

        return student_data;
    };

    articlecolumns = [
        {
            dataField: "student_name",
            text: "Student Name",
            sort: true,
        },
        {
            dataField: "roll_no",
            text: "Roll No",
            sort: true,
        },
        {
            dataField: "class_name",
            text: "Class",
            sort: true,
        },
        {
            dataField: "branch_name",
            text: "Branch",
            sort: true,
        },
        {
            dataField: "exam_name",
            text: "Exam",
            sort: true,
        },
        {
            dataField: "section_name",
            text: "Section",
            sort: true,
        },
        {
            dataField: "student_mobile",
            text: "Contact No",
            sort: true,
        },
        {
            dataField: "total_amount",
            text: "Total Amount"
        },
        {
            dataField: "pending_amount",
            text: "Pending Amount"
        },
        {
            dataField: "paid_amount",
            text: "Paid Amount"
        },
        {
            dataField: "Fee Status",
            formatter: this.performanceFunc.bind(this),
            text: "Fee Status"
        },
        {
            dataField: "Fee Report",
            formatter: this.reportPerformanceFunc.bind(this),
            text: "Fee Report"
        },

    ];

    showFeeModal = (studentData, total_amount, mobile, tutionFee, individualDetails, student_name, exam_name, class_name, roll_no, branch_id) => {
        this.setState({
            feeModal: true,
            studentPaymentData: studentData,
            totalAmount: total_amount,
            studentMobile: mobile,
            tutionFee: tutionFee,
            individualDetails: individualDetails,
            student_name: student_name,
            exam_name: exam_name,
            class_name: class_name,
            roll_no: roll_no,
            row_branch_id: branch_id
        })
    };

    performanceFunc(cell, row, rowIndex, formatExtraData) {
        console.log("rowwwwwwwwwww", row)
        return (<>
            <div className="actions-buttons d-flex justify-content-center align-items-top" onClick={() => this.showFeeModal(row.term_details, row.total_amount, row.student_mobile, row.tutionFee, row.individualDetails, row.student_name, row.exam_name, row.class_name, row.roll_no, row.branch)}>
                <Button variant="link" name="edit" className="text-theme" style={{ cursor: "pointer" }}>
                    <i className="far fa-edit" />
                </Button>
            </div>
        </>)
    };

    reportPerformanceFunc(cell, row, rowIndex, formatExtraData) {
        console.log("rowwwwwwwwwww", row)


        return (<>
            <div className="actions-buttons d-flex justify-content-center align-items-top" >
                <Button variant="link" name="edit" className="text-theme" style={{ cursor: "pointer" }} onClick={() => this.showDateWiseFeeModal(row.term_details, row.student_name, row.exam_name, row.class_name, row.individualDetails, row.roll_no, row.branch)}>
                    Report
                </Button>
            </div>
        </>)
    }

    showDateWiseFeeModal = (term_details, student_name, exam_name, class_name, individualDetails, roll_no, branch_id) => {
        this.setState({
            studentPaymentData: term_details,
            student_name: student_name,
            exam_name: exam_name,
            class_name: class_name,
            individualDetails: individualDetails,
            roll_no: roll_no,
            row_branch_id:branch_id
        });


        console.log("dddddd", this.state.tutionFee)
        this.setState({ feeReportDateWiseModal: true })



    }

    render() {


        console.log("dataaa", this.articlecolumns[1].dataField);

        const getOrganisationProfile = this.props.getOrganisationProfile;
        const loading3 = getOrganisationProfile.loading;
        const error3 = getOrganisationProfile.error;

        console.log("oioioioioi", this.state);

        console.log("getOrganisationProfile", this.props.getOrganisationProfile);
        if (error3 !== undefined) {
            alert("Server Error. " + error3.message);
            return null;
        }

        if (loading3) return null;


        let StudentsFilterData = [];
        if (
            (this.state.studentnameSearch != "0" ||
                this.state.packageSearch != "0" ||
                this.state.classSearch != "0" ||
                this.state.sectionSearch != "0" ||
                this.state.branchSearch != "0" ||
                this.state.categorySearch != "0" ||
                this.state.examSearch != "0")

        ) {
            StudentsFilterData = this.props.getStudentPaymentDetails;
            if (this.state.classSearch != "0") {
                StudentsFilterData = StudentsFilterData.filter((a) => a.class_id == this.state.classSearch);
            }
            if (this.state.examSearch != "0") {
                StudentsFilterData = StudentsFilterData.filter((a) => a.exam_id == this.state.examSearch);
            }
            if (this.state.sectionSearch != "0") {
                StudentsFilterData = StudentsFilterData.filter((a) => a.section_id == this.state.sectionSearch);
            }
            if (this.state.branchSearch != "0") {
                StudentsFilterData = StudentsFilterData.filter((a) => a.branch_id == this.state.branchSearch);
            }
        }
        else {
            StudentsFilterData = this.props.getStudentPaymentDetails;
        }
        return (
            <Container>
                <Row className="mt-3">
                    <Col sm={12}>
                        <Card className="border-0 shadow-sm mb-4">
                            <Card.Header className="bg-white">
                                <Row>
                                    <Col lg={3} md={12} sm={12}>
                                        {/* BRANCH */}
                                        <SelectDropDown
                                            stateData={this.state.branchSearchval}
                                            handleChange={this.selecthandleInputChange}
                                            name="branchSearch"
                                            options={this.dropDownGetValues("branchSearch")}
                                            placeholderName={'Select Branch'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                        />
                                    </Col>

                                    <Col lg={3} md={12} sm={12}>
                                        {/* EXAMS */}
                                        <SelectDropDown
                                            stateData={this.state.examSearchval}
                                            handleChange={this.selecthandleInputChange}
                                            name="examSearch"
                                            options={this.state.getExams}
                                            placeholderName={'Select Exam'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                        />
                                    </Col>

                                    <Col lg={3} md={12} sm={12}>
                                        {/* CLASS */}
                                        <SelectDropDown
                                            stateData={this.state.classSearchval}
                                            handleChange={this.selecthandleInputChange}
                                            name="classSearch"
                                            options={this.state.getClasses}
                                            placeholderName={'Select Class'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                        />
                                    </Col>

                                    <Col lg={3} md={12} sm={12}>
                                        {/* SECTION */}
                                        <SelectDropDown
                                            stateData={this.state.sectionSearchval}
                                            handleChange={this.selecthandleInputChange}
                                            name="sectionSearch"
                                            options={this.state.getSections}
                                            placeholderName={'Select Section'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                        />
                                    </Col>
                                </Row>
                            </Card.Header>

                            <Card.Body>
                                <CardLessDataTable
                                    parentData={this.tableData(StudentsFilterData)}
                                    particlecolumns={this.articlecolumns}
                                    search={true}
                                    name="hostel_attendance"
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <FeeStatusModal
                    show={this.state.feeModal}
                    onHide={() => this.setState({ feeModal: false })}
                    studentPaymentData={this.state.studentPaymentData}
                    globals={this.props.globals}
                    totalAmount={this.state.totalAmount}
                    studentMobile={this.state.studentMobile}
                    tutionFee={this.state.tutionFee}
                    individualDetails={this.state.individualDetails}
                    getPaymentModes={this.props.getPaymentModes}
                    studentName={this.state.student_name}
                    examName={this.state.exam_name}
                    getOrganisationProfile={this.props.getOrganisationProfile.getOrganisationProfile}
                    stateData={this.state}
                />

                <FeeReportDateWise
                    show={this.state.feeReportDateWiseModal}
                    onHide={() => this.setState({ feeReportDateWiseModal: false })}
                    studentPaymentData={this.state.studentPaymentData}
                    studentName={this.state.student_name}
                    examName={this.state.exam_name}
                    class_name={this.state.class_name}
                    getPaymentModes={this.props.getPaymentModes}
                    roll_no={this.state.roll_no}
                    getOrganisationProfile={this.props.getOrganisationProfile.getOrganisationProfile}
                    globals={this.props.globals}
                    stateData={this.state}
                />
            </Container>
        )
    }
}

export default withRouter(withApollo(compose(
    graphql(gql` 
    query($institution_id: Int!) {
        getOrganisationProfile(institution_id: $institution_id){
            id
            organisation_name
            chairman
            contact_no
            complete_address
            region_id
            logo
            hod
            hod_mobile
            principal
            principal_mobile
            vice_principal
            vice_principal_mobile
            timestamp
             branch_wise_data{
                branch_id
                branch_name
                branch_wise_address
            }
        }
    }
    `,
        {
            options: props => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid"))
                },
            }), name: "getOrganisationProfile"
        }
    ))(StudentPayments)));